module.exports = __webpack_public_path__ + "static/media/ideia.13dd5f0e.svg";